import ArrowBack from "@mui/icons-material/ArrowBack";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import Paper from "@mui/material/Paper";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import DriverForm from "../../components/forms/DriverForm";

export default function AddDriver() {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo({ top: "0", behavior: "smooth" });
  }, []);
  return (
    <Box component={Paper} elevation={0}>
      <Box px={3} py={2}>
        <IconButton
          onClick={() => {
            navigate(-1);
          }}
        >
          <ArrowBack />
        </IconButton>
      </Box>
      <Divider />
      <Box px={3} my={3}>
        <DriverForm />
      </Box>
    </Box>
  );
}
